module.exports = __webpack_public_path__ + "img/img1.ead53268.png";